import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { baseColors, RelodeTheme, Text } from "../..";
import { LicenseJobQualification } from "../../../domain";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            noPadding: {
                padding: theme.spacing(0),
                [theme.breakpoints.down("md")]: {
                    padding: theme.spacing(2),
                },
            },
            listItem: {
                padding: theme.spacing(0, 4, 0, 4),
                margin: 0,
                listStyle: "disc",
            },
            header: {
                marginBottom: 15,
            },
            preparingContainer: {
                padding: theme.spacing(3.5, 0),
                backgroundColor: baseColors.cool_gray,
                border: "1px solid",
                borderColor: baseColors.warm_gray,
                width: "220px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
                textAlign: "center",
                color: baseColors.light_black,
            },
            preparingWait: {
                display: "flex",
                alignItems: "center",
                gap: "4px",
            },
        }),
    { name: "QualificationView" }
);

export const LicenseJobQualificationView = (props: {
    qual: LicenseJobQualification;
    isAnyOf: boolean;
}) => {
    const { licenses } = props.qual;
    const classes = useStyles({});

    if (licenses.length > 1) {
        return (
            <li>
                <Text>
                    {props.isAnyOf ? "ANY" : "ALL"} of the following valid
                    licenses/certifications:
                </Text>
                <ul className={classes.listItem}>
                    {licenses.map(l => (
                        <li key={l.licenseTagId}>
                            <Text variant="body1">
                                {`${l.licenseTagName ?? l.licenseCustomText} ${
                                    l.stateTagId ? `in ${l.stateTagName}` : ""
                                }`}
                            </Text>
                        </li>
                    ))}
                </ul>
            </li>
        );
    } else {
        return (
            <>
                {licenses.map(l => (
                    <li key={l.licenseTagId}>
                        <Text variant="body1">
                            {`Valid ${
                                l.licenseTagName ?? l.licenseCustomText
                            } ${
                                l.stateTagId
                                    ? `in the state of ${l.stateTagName}`
                                    : ""
                            }`}
                        </Text>
                    </li>
                ))}
            </>
        );
    }
};
